// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.matching-page {
  max-width: 600px;
  margin: auto;
  padding: 30px 20px;
  min-height: 100vh;
  background: var(--bg-100);
  padding-bottom: 80px;
}

/* HEADER */

.matching-header h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--primary-100);
}

.matching-header p {
  color: var(--text-200);
  margin-top: 6px;
  font-size: 14px;
}

/* GRID */

.matching-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 18px;
}

.match-card {
  background: var(--primary-300);
  border-radius: 18px;
  padding: 20px;
  position: relative;
  box-shadow: 0 12px 30px rgba(78, 119, 153, 0.08);
  border: 1px solid rgba(78, 119, 153, 0.1);
  transition: all 0.25s ease;
  height: 250px;
}

.match-card-mine {
  background: var(--primary-300);
  border-radius: 18px;
  padding: 20px;
  position: relative;
  box-shadow: 0 12px 30px rgba(78, 119, 153, 0.08);
  border: 1px solid rgba(78, 119, 153, 0.1);
  transition: all 0.25s ease;
  /* height: 250px; */
}

.match-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 18px 40px rgba(78, 119, 153, 0.15);
}

.match-header img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  border: 3px solid var(--primary-100);
}

.role-badge {
  display: inline-block;
  margin-top: 6px;
  font-size: 11px;
  padding: 5px 12px;
  border-radius: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
  background: var(--bg-300);
  color: var(--primary-100);
}

.match-body {
  flex:1 1;

  display:flex;
  flex-direction:column;
  justify-content:flex-start;
  margin: 16px 0;
  font-size: 14px;
  color: var(--text-100);
}

.match-body strong {
  color: var(--primary-200);
}

.btn-primary {
  flex: 1 1;
  background: var(--primary-100);
  color: white;
  border: none;
  padding: 11px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  transition: 0.2s ease;
}

.btn-primary:hover {
  background: var(--primary-200);
}

.btn-outline {
  flex: 1 1;
  border: 1.5px solid var(--primary-100);
  background: transparent;
  color: var(--primary-100);
  padding: 11px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  transition: 0.2s ease;
}

.btn-outline:hover {
  background: var(--bg-300);
}

.suggestion-row {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  padding: 12px 2px 24px;
  scroll-snap-type: x mandatory;
}

.suggestion-row::-webkit-scrollbar {
  height: 5px;
}

.suggestion-row::-webkit-scrollbar-thumb {
  background: var(--accent-100);
  border-radius: 10px;
}


.match-footer {
  display: flex;
  gap: 15px;
}

.match-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: var(--primary-200);
  color: white;
  font-size: 11px;
  padding: 4px 8px;
  border-radius: 8px;
  font-weight: 600;
}


.skeleton {
  background: #e5edf1;
  animation: matching-skeleton-pulse 1.2s ease-in-out infinite alternate;
  border-radius: 6px;
}

@keyframes matching-skeleton-pulse {
  from { opacity: .55; }
  to { opacity: 1; }
}

@keyframes skeleton-loading {
  0% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0 50%;
  }
}

.skeleton.avatar {
  width: 40px;
  /* height: 40px; */
  border-radius: 50%;
}

.skeleton.text {
  width: 120px;
  height: 14px;
  margin-bottom: 6px;
}

.skeleton.text.small {
  width: 80px;
}

.avatar-placeholder {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #eee;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* CarrerUp matching command deck: presentation layer only. */
.matching-page {
  box-sizing: border-box;
  width: min(1240px, calc(100% - 48px));
  max-width: none;
  min-height: calc(100vh - 64px);
  margin: 0 auto;
  padding: 24px 0 58px;
  color: #1d394f;
  background: transparent;
  font-family: Inter, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.matching-hero {
  position: relative;
  margin: 0 0 16px;
  padding: 25px 26px;
  overflow: hidden;
  /* border: 1px solid rgba(78, 119, 153, .17); */
  border-radius: 20px;
  background: #fbfcfd;
  box-shadow: 0 15px 35px rgba(30, 63, 88, .08), inset 0 1px #ffffff;
}

.matching-hero::before {
  content: "";
  position: absolute;
  top: 0;
  right: 28px;
  left: 28px;
  height: 3px;
  border-radius: 0 0 4px 4px;
  background: #e95a13;
}

.matching-header h1 {
  margin: 0;
  color: #1d394f;
  font-family: inherit;
  font-size: 1.25rem;
  font-weight: 850;
  letter-spacing: -.025em;
}

.matching-header p {
  max-width: 650px;
  margin: 7px 0 0;
  color: #71899b;
  font-family: inherit;
  font-size: .84rem;
  font-weight: 550;
  line-height: 1.55;
}

.matching-section { min-width: 0; }
.matching-confirmed-section { margin-top: 30px; }
.matching-confirmed-section > .matching-header { margin: 0 0 14px; padding: 0 2px; }
.matching-confirmed-section > .matching-header h1 { font-size: 1.05rem; }

.matching-list-toolbar {
  display: flex;
  align-items: center;
  margin: 0 0 11px;
}

.matching-search {
  display: flex;
  align-items: center;
  width: min(390px, 100%);
  height: 43px;
  gap: 10px;
  padding: 0 13px;
  border: 1px solid rgba(78, 119, 153, .17);
  border-radius: 12px;
  background: #f1f5f7;
  transition: .18s ease;
}

.matching-search:focus-within {
  border-color: #e95a13;
  background: #ffffff;
  box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);
}

.matching-search svg { flex: 0 0 auto; color: #4e7799; font-size: .78rem; }
.matching-search input { width: 100%; min-width: 0; border: 0; outline: 0; color: #29475e; background: transparent; font-family: inherit; font-size: .78rem; font-weight: 600; }
.matching-search input::placeholder { color: #71899b; }

.matching-list-scroll {
  max-height: 480px;
  padding: 2px 8px 2px 2px;
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-width: thin;
  scrollbar-color: #94a9ba transparent;
}

.matching-list-scroll::-webkit-scrollbar { width: 6px; }
.matching-list-scroll::-webkit-scrollbar-thumb { border-radius: 999px; background: #94a9ba; }

.matching-grid.matching-list {
  grid-template-columns: 1fr;
  gap: 10px;
}

.matching-list .match-card-mine {
  display: grid;
  grid-template-columns: minmax(180px, .8fr) minmax(0, 1.25fr) minmax(126px, .42fr);
  align-items: center;
  min-height: 96px;
  gap: 18px;
  padding: 15px 18px;
}

.matching-list .match-body { margin: 0; }
.matching-list .match-footer { margin: 0; }
.matching-list .match-footer .btn-primary { width: 100%; }
.matching-list .match-badge { top: 8px; right: 12px; }

.matching-page .suggestion-row {
  gap: 13px;
  padding: 2px 2px 14px;
  scroll-padding-left: 2px;
  scrollbar-width: thin;
  scrollbar-color: #94a9ba transparent;
}

.matching-page .suggestion-row::-webkit-scrollbar { height: 5px; }
.matching-page .suggestion-row::-webkit-scrollbar-thumb { background: #94a9ba; border-radius: 10px; }

.matching-page .match-card,
.matching-page .match-card-mine {
  box-sizing: border-box;
  min-height: 230px;
  height: auto;
  padding: 17px;
  overflow: hidden;
  border: 1px solid rgba(78, 119, 153, .16);
  border-radius: 17px;
  background: #fbfcfd;
  box-shadow: 0 10px 24px rgba(30, 63, 88, .07), inset 0 1px #ffffff;
}

.matching-page .match-card { position: relative; }
.matching-page .match-card::before,
.matching-page .match-card-mine::before {
  content: "";
  position: absolute;
  top: 0;
  right: 22px;
  left: 22px;
  height: 2px;
  background: rgba(78, 119, 153, .3);
}

.matching-page .match-card:hover,
.matching-page .match-card-mine:hover {
  border-color: rgba(233, 90, 19, .27);
  box-shadow: 0 15px 30px rgba(30, 63, 88, .11), inset 0 1px #ffffff;
  transform: translateY(-3px);
}

.matching-page .match-header {
  display: flex;
  align-items: center;
  gap: 11px;
  min-width: 0;
}

.matching-page .match-header img,
.matching-page .avatar-placeholder {
  width: 50px;
  height: 50px;
  flex: 0 0 50px;
  overflow: hidden;
  border: 2px solid #ffffff;
  border-radius: 14px;
  color: #ffffff;
  background: #4e7799;
  box-shadow: 0 5px 12px rgba(78, 119, 153, .18);
  object-fit: cover;
}

.matching-page .match-header h3,
.matching-page .match-header strong {
  overflow: hidden;
  margin: 0 0 4px;
  color: #29475e;
  font-family: inherit;
  font-size: .9rem;
  font-weight: 850;
  letter-spacing: -.01em;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.matching-page .role-badge {
  margin-top: 0;
  padding: 5px 8px;
  border: 1px solid rgba(233, 90, 19, .18);
  border-radius: 999px;
  color: #a83e0d;
  background: #fff3ec;
  font-family: inherit;
  font-size: .62rem;
  font-weight: 800;
  letter-spacing: .045em;
  text-transform: uppercase;
}

.matching-page .match-body {
  gap: 5px;
  margin: 15px 0;
  color: #4e7799;
  font-family: inherit;
  font-size: .76rem;
  font-weight: 650;
  line-height: 1.5;
}

.matching-page .match-body p { margin: 0; }
.matching-page .match-body strong { color: #29475e; font-weight: 800; }
.matching-page .match-footer { gap: 8px; margin-top: auto; }

.matching-page .btn-primary,
.matching-page .btn-outline {
  min-height: 40px;
  border-radius: 11px;
  font-family: inherit;
  font-size: .73rem;
  font-weight: 850;
  transition: .18s ease;
}

.matching-page .btn-primary { border: 1px solid #e95a13; background: #e95a13; box-shadow: 0 7px 14px rgba(233, 90, 19, .16); }
.matching-page .btn-primary:hover { background: #d84f0d; }
.matching-page .match-badge { top: 14px; right: 14px; padding: 5px 8px; border: 1px solid rgba(78, 119, 153, .15); border-radius: 8px; color: #4e7799; background: #edf3f6; font-family: inherit; font-size: .58rem; font-weight: 850; letter-spacing: .04em; text-transform: uppercase; }

.matching-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
}

.matching-empty-state {
  grid-column: 1 / -1;
  margin: 0;
  padding: 22px;
  border: 1px dashed rgba(78, 119, 153, .28);
  border-radius: 15px;
  color: #71899b;
  background: #fbfcfd;
  font-size: .82rem;
  font-weight: 650;
  text-align: center;
}

.matching-page .skeleton { background: #e5edf1; animation: matching-card-pulse 1.15s ease-in-out infinite alternate; }
@keyframes matching-card-pulse { from { opacity: .55; } to { opacity: 1; } }

.matching-page button:focus-visible { outline: 2px solid #e95a13; outline-offset: 2px; }

@media (max-width: 1050px) {
  .matching-page { width: min(860px, calc(100% - 36px)); }
  .matching-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 768px) {
  .matching-page { width: 100%; min-height: 0; padding: 14px 12px 88px; }
  .matching-hero { margin: 8px -12px 10px;  border-radius: 0 0 17px 17px; }
  .matching-hero::before { right: 18px; left: 18px; }
  .matching-header h1 { font-size: 1.08rem; }
  .matching-header p { font-size: .76rem; }
  .matching-page .suggestion-row { gap: 10px; padding: 1px 0 12px; }
  .matching-grid { grid-template-columns: 1fr; gap: 11px; }
  .matching-confirmed-section { margin-top: 22px; }
  .matching-list-toolbar { margin-bottom: 9px; }
  .matching-search { width: 100%; }
  .matching-list-scroll { max-height: min(420px, calc(100dvh - 345px)); padding-right: 4px; }
  .matching-list .match-card-mine { display: block; min-height: 205px; padding: 15px; }
  .matching-list .match-body { margin: 15px 0; }
  .matching-list .match-footer { margin-top: auto; }
  .matching-page .match-card-mine { min-height: 205px; padding: 15px; border-radius: 15px; }
  .matching-page .match-badge { top: 12px; right: 12px; }
}
`, "",{"version":3,"sources":["webpack://./src/componentsL/matching/Matching.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,WAAW;;AAEX;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA,SAAS;;AAET;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gDAAgD;EAChD,yCAAyC;EACzC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,gDAAgD;EAChD,yCAAyC;EACzC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,QAAM;;EAEN,YAAY;EACZ,qBAAqB;EACrB,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,sCAAsC;EACtC,uBAAuB;EACvB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;AACrB;;;AAGA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,sEAAsE;EACtE,kBAAkB;AACpB;;AAEA;EACE,OAAO,YAAY,EAAE;EACrB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,6DAA6D;AAC7D;EACE,sBAAsB;EACtB,qCAAqC;EACrC,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,uBAAuB;EACvB,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB;EACnB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,oBAAoB,YAAY,EAAE;AAClC,8BAA8B,gBAAgB,EAAE;AAChD,iDAAiD,gBAAgB,EAAE,cAAc,EAAE;AACnF,oDAAoD,kBAAkB,EAAE;;AAExE;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;EACT,eAAe;EACf,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA,uBAAuB,cAAc,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC1E,yBAAyB,WAAW,EAAE,YAAY,EAAE,SAAS,EAAE,UAAU,EAAE,cAAc,EAAE,uBAAuB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC/K,sCAAsC,cAAc,EAAE;;AAEtD;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,2CAA2C,UAAU,EAAE;AACvD,iDAAiD,oBAAoB,EAAE,mBAAmB,EAAE;;AAE5F;EACE,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,iFAAiF;EACjF,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA,6BAA6B,SAAS,EAAE;AACxC,+BAA+B,SAAS,EAAE;AAC1C,4CAA4C,WAAW,EAAE;AACzD,8BAA8B,QAAQ,EAAE,WAAW,EAAE;;AAErD;EACE,SAAS;EACT,qBAAqB;EACrB,wBAAwB;EACxB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA,oDAAoD,WAAW,EAAE;AACjE,0DAA0D,mBAAmB,EAAE,mBAAmB,EAAE;;AAEpG;;EAEE,sBAAsB;EACtB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,mBAAmB;EACnB,kEAAkE;AACpE;;AAEA,6BAA6B,kBAAkB,EAAE;AACjD;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,WAAW;EACX,kCAAkC;AACpC;;AAEA;;EAEE,oCAAoC;EACpC,kEAAkE;EAClE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;EAC9C,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,wCAAwC;EACxC,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,+BAA+B,SAAS,EAAE;AAC1C,oCAAoC,cAAc,EAAE,gBAAgB,EAAE;AACtE,+BAA+B,QAAQ,EAAE,gBAAgB,EAAE;;AAE3D;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA,8BAA8B,yBAAyB,EAAE,mBAAmB,EAAE,6CAA6C,EAAE;AAC7H,oCAAoC,mBAAmB,EAAE;AACzD,8BAA8B,SAAS,EAAE,WAAW,EAAE,gBAAgB,EAAE,yCAAyC,EAAE,kBAAkB,EAAE,cAAc,EAAE,mBAAmB,EAAE,oBAAoB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,yBAAyB,EAAE;;AAEzR;EACE,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2BAA2B,mBAAmB,EAAE,mEAAmE,EAAE;AACrH,iCAAiC,OAAO,YAAY,EAAE,EAAE,KAAK,UAAU,EAAE,EAAE;;AAE3E,sCAAsC,0BAA0B,EAAE,mBAAmB,EAAE;;AAEvF;EACE,iBAAiB,oCAAoC,EAAE;EACvD,iBAAiB,gDAAgD,EAAE;AACrE;;AAEA;EACE,iBAAiB,WAAW,EAAE,aAAa,EAAE,uBAAuB,EAAE;EACtE,iBAAiB,sBAAsB,GAAG,4BAA4B,EAAE;EACxE,yBAAyB,WAAW,EAAE,UAAU,EAAE;EAClD,sBAAsB,kBAAkB,EAAE;EAC1C,qBAAqB,iBAAiB,EAAE;EACxC,iCAAiC,SAAS,EAAE,mBAAmB,EAAE;EACjE,iBAAiB,0BAA0B,EAAE,SAAS,EAAE;EACxD,8BAA8B,gBAAgB,EAAE;EAChD,yBAAyB,kBAAkB,EAAE;EAC7C,mBAAmB,WAAW,EAAE;EAChC,wBAAwB,4CAA4C,EAAE,kBAAkB,EAAE;EAC1F,kCAAkC,cAAc,EAAE,iBAAiB,EAAE,aAAa,EAAE;EACpF,6BAA6B,cAAc,EAAE;EAC7C,+BAA+B,gBAAgB,EAAE;EACjD,kCAAkC,iBAAiB,EAAE,aAAa,EAAE,mBAAmB,EAAE;EACzF,8BAA8B,SAAS,EAAE,WAAW,EAAE;AACxD","sourcesContent":[".matching-page {\n  max-width: 600px;\n  margin: auto;\n  padding: 30px 20px;\n  min-height: 100vh;\n  background: var(--bg-100);\n  padding-bottom: 80px;\n}\n\n/* HEADER */\n\n.matching-header h1 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--primary-100);\n}\n\n.matching-header p {\n  color: var(--text-200);\n  margin-top: 6px;\n  font-size: 14px;\n}\n\n/* GRID */\n\n.matching-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 18px;\n}\n\n.match-card {\n  background: var(--primary-300);\n  border-radius: 18px;\n  padding: 20px;\n  position: relative;\n  box-shadow: 0 12px 30px rgba(78, 119, 153, 0.08);\n  border: 1px solid rgba(78, 119, 153, 0.1);\n  transition: all 0.25s ease;\n  height: 250px;\n}\n\n.match-card-mine {\n  background: var(--primary-300);\n  border-radius: 18px;\n  padding: 20px;\n  position: relative;\n  box-shadow: 0 12px 30px rgba(78, 119, 153, 0.08);\n  border: 1px solid rgba(78, 119, 153, 0.1);\n  transition: all 0.25s ease;\n  /* height: 250px; */\n}\n\n.match-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 18px 40px rgba(78, 119, 153, 0.15);\n}\n\n.match-header img {\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  border: 3px solid var(--primary-100);\n}\n\n.role-badge {\n  display: inline-block;\n  margin-top: 6px;\n  font-size: 11px;\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-weight: 600;\n  letter-spacing: 0.5px;\n  background: var(--bg-300);\n  color: var(--primary-100);\n}\n\n.match-body {\n  flex:1;\n\n  display:flex;\n  flex-direction:column;\n  justify-content:flex-start;\n  margin: 16px 0;\n  font-size: 14px;\n  color: var(--text-100);\n}\n\n.match-body strong {\n  color: var(--primary-200);\n}\n\n.btn-primary {\n  flex: 1;\n  background: var(--primary-100);\n  color: white;\n  border: none;\n  padding: 11px;\n  border-radius: 12px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: 0.2s ease;\n}\n\n.btn-primary:hover {\n  background: var(--primary-200);\n}\n\n.btn-outline {\n  flex: 1;\n  border: 1.5px solid var(--primary-100);\n  background: transparent;\n  color: var(--primary-100);\n  padding: 11px;\n  border-radius: 12px;\n  cursor: pointer;\n  font-weight: 600;\n  transition: 0.2s ease;\n}\n\n.btn-outline:hover {\n  background: var(--bg-300);\n}\n\n.suggestion-row {\n  display: flex;\n  gap: 16px;\n  overflow-x: auto;\n  padding: 12px 2px 24px;\n  scroll-snap-type: x mandatory;\n}\n\n.suggestion-row::-webkit-scrollbar {\n  height: 5px;\n}\n\n.suggestion-row::-webkit-scrollbar-thumb {\n  background: var(--accent-100);\n  border-radius: 10px;\n}\n\n\n.match-footer {\n  display: flex;\n  gap: 15px;\n}\n\n.match-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: var(--primary-200);\n  color: white;\n  font-size: 11px;\n  padding: 4px 8px;\n  border-radius: 8px;\n  font-weight: 600;\n}\n\n\n.skeleton {\n  background: #e5edf1;\n  animation: matching-skeleton-pulse 1.2s ease-in-out infinite alternate;\n  border-radius: 6px;\n}\n\n@keyframes matching-skeleton-pulse {\n  from { opacity: .55; }\n  to { opacity: 1; }\n}\n\n@keyframes skeleton-loading {\n  0% {\n    background-position: 100% 50%;\n  }\n\n  100% {\n    background-position: 0 50%;\n  }\n}\n\n.skeleton.avatar {\n  width: 40px;\n  /* height: 40px; */\n  border-radius: 50%;\n}\n\n.skeleton.text {\n  width: 120px;\n  height: 14px;\n  margin-bottom: 6px;\n}\n\n.skeleton.text.small {\n  width: 80px;\n}\n\n.avatar-placeholder {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #eee;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* CarrerUp matching command deck: presentation layer only. */\n.matching-page {\n  box-sizing: border-box;\n  width: min(1240px, calc(100% - 48px));\n  max-width: none;\n  min-height: calc(100vh - 64px);\n  margin: 0 auto;\n  padding: 24px 0 58px;\n  color: #1d394f;\n  background: transparent;\n  font-family: Inter, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n}\n\n.matching-hero {\n  position: relative;\n  margin: 0 0 16px;\n  padding: 25px 26px;\n  overflow: hidden;\n  /* border: 1px solid rgba(78, 119, 153, .17); */\n  border-radius: 20px;\n  background: #fbfcfd;\n  box-shadow: 0 15px 35px rgba(30, 63, 88, .08), inset 0 1px #ffffff;\n}\n\n.matching-hero::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 28px;\n  left: 28px;\n  height: 3px;\n  border-radius: 0 0 4px 4px;\n  background: #e95a13;\n}\n\n.matching-header h1 {\n  margin: 0;\n  color: #1d394f;\n  font-family: inherit;\n  font-size: 1.25rem;\n  font-weight: 850;\n  letter-spacing: -.025em;\n}\n\n.matching-header p {\n  max-width: 650px;\n  margin: 7px 0 0;\n  color: #71899b;\n  font-family: inherit;\n  font-size: .84rem;\n  font-weight: 550;\n  line-height: 1.55;\n}\n\n.matching-section { min-width: 0; }\n.matching-confirmed-section { margin-top: 30px; }\n.matching-confirmed-section > .matching-header { margin: 0 0 14px; padding: 0 2px; }\n.matching-confirmed-section > .matching-header h1 { font-size: 1.05rem; }\n\n.matching-list-toolbar {\n  display: flex;\n  align-items: center;\n  margin: 0 0 11px;\n}\n\n.matching-search {\n  display: flex;\n  align-items: center;\n  width: min(390px, 100%);\n  height: 43px;\n  gap: 10px;\n  padding: 0 13px;\n  border: 1px solid rgba(78, 119, 153, .17);\n  border-radius: 12px;\n  background: #f1f5f7;\n  transition: .18s ease;\n}\n\n.matching-search:focus-within {\n  border-color: #e95a13;\n  background: #ffffff;\n  box-shadow: 0 0 0 4px rgba(233, 90, 19, .1);\n}\n\n.matching-search svg { flex: 0 0 auto; color: #4e7799; font-size: .78rem; }\n.matching-search input { width: 100%; min-width: 0; border: 0; outline: 0; color: #29475e; background: transparent; font-family: inherit; font-size: .78rem; font-weight: 600; }\n.matching-search input::placeholder { color: #71899b; }\n\n.matching-list-scroll {\n  max-height: 480px;\n  padding: 2px 8px 2px 2px;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-width: thin;\n  scrollbar-color: #94a9ba transparent;\n}\n\n.matching-list-scroll::-webkit-scrollbar { width: 6px; }\n.matching-list-scroll::-webkit-scrollbar-thumb { border-radius: 999px; background: #94a9ba; }\n\n.matching-grid.matching-list {\n  grid-template-columns: 1fr;\n  gap: 10px;\n}\n\n.matching-list .match-card-mine {\n  display: grid;\n  grid-template-columns: minmax(180px, .8fr) minmax(0, 1.25fr) minmax(126px, .42fr);\n  align-items: center;\n  min-height: 96px;\n  gap: 18px;\n  padding: 15px 18px;\n}\n\n.matching-list .match-body { margin: 0; }\n.matching-list .match-footer { margin: 0; }\n.matching-list .match-footer .btn-primary { width: 100%; }\n.matching-list .match-badge { top: 8px; right: 12px; }\n\n.matching-page .suggestion-row {\n  gap: 13px;\n  padding: 2px 2px 14px;\n  scroll-padding-left: 2px;\n  scrollbar-width: thin;\n  scrollbar-color: #94a9ba transparent;\n}\n\n.matching-page .suggestion-row::-webkit-scrollbar { height: 5px; }\n.matching-page .suggestion-row::-webkit-scrollbar-thumb { background: #94a9ba; border-radius: 10px; }\n\n.matching-page .match-card,\n.matching-page .match-card-mine {\n  box-sizing: border-box;\n  min-height: 230px;\n  height: auto;\n  padding: 17px;\n  overflow: hidden;\n  border: 1px solid rgba(78, 119, 153, .16);\n  border-radius: 17px;\n  background: #fbfcfd;\n  box-shadow: 0 10px 24px rgba(30, 63, 88, .07), inset 0 1px #ffffff;\n}\n\n.matching-page .match-card { position: relative; }\n.matching-page .match-card::before,\n.matching-page .match-card-mine::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 22px;\n  left: 22px;\n  height: 2px;\n  background: rgba(78, 119, 153, .3);\n}\n\n.matching-page .match-card:hover,\n.matching-page .match-card-mine:hover {\n  border-color: rgba(233, 90, 19, .27);\n  box-shadow: 0 15px 30px rgba(30, 63, 88, .11), inset 0 1px #ffffff;\n  transform: translateY(-3px);\n}\n\n.matching-page .match-header {\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  min-width: 0;\n}\n\n.matching-page .match-header img,\n.matching-page .avatar-placeholder {\n  width: 50px;\n  height: 50px;\n  flex: 0 0 50px;\n  overflow: hidden;\n  border: 2px solid #ffffff;\n  border-radius: 14px;\n  color: #ffffff;\n  background: #4e7799;\n  box-shadow: 0 5px 12px rgba(78, 119, 153, .18);\n  object-fit: cover;\n}\n\n.matching-page .match-header h3,\n.matching-page .match-header strong {\n  overflow: hidden;\n  margin: 0 0 4px;\n  color: #29475e;\n  font-family: inherit;\n  font-size: .9rem;\n  font-weight: 850;\n  letter-spacing: -.01em;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.matching-page .role-badge {\n  margin-top: 0;\n  padding: 5px 8px;\n  border: 1px solid rgba(233, 90, 19, .18);\n  border-radius: 999px;\n  color: #a83e0d;\n  background: #fff3ec;\n  font-family: inherit;\n  font-size: .62rem;\n  font-weight: 800;\n  letter-spacing: .045em;\n  text-transform: uppercase;\n}\n\n.matching-page .match-body {\n  gap: 5px;\n  margin: 15px 0;\n  color: #4e7799;\n  font-family: inherit;\n  font-size: .76rem;\n  font-weight: 650;\n  line-height: 1.5;\n}\n\n.matching-page .match-body p { margin: 0; }\n.matching-page .match-body strong { color: #29475e; font-weight: 800; }\n.matching-page .match-footer { gap: 8px; margin-top: auto; }\n\n.matching-page .btn-primary,\n.matching-page .btn-outline {\n  min-height: 40px;\n  border-radius: 11px;\n  font-family: inherit;\n  font-size: .73rem;\n  font-weight: 850;\n  transition: .18s ease;\n}\n\n.matching-page .btn-primary { border: 1px solid #e95a13; background: #e95a13; box-shadow: 0 7px 14px rgba(233, 90, 19, .16); }\n.matching-page .btn-primary:hover { background: #d84f0d; }\n.matching-page .match-badge { top: 14px; right: 14px; padding: 5px 8px; border: 1px solid rgba(78, 119, 153, .15); border-radius: 8px; color: #4e7799; background: #edf3f6; font-family: inherit; font-size: .58rem; font-weight: 850; letter-spacing: .04em; text-transform: uppercase; }\n\n.matching-grid {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.matching-empty-state {\n  grid-column: 1 / -1;\n  margin: 0;\n  padding: 22px;\n  border: 1px dashed rgba(78, 119, 153, .28);\n  border-radius: 15px;\n  color: #71899b;\n  background: #fbfcfd;\n  font-size: .82rem;\n  font-weight: 650;\n  text-align: center;\n}\n\n.matching-page .skeleton { background: #e5edf1; animation: matching-card-pulse 1.15s ease-in-out infinite alternate; }\n@keyframes matching-card-pulse { from { opacity: .55; } to { opacity: 1; } }\n\n.matching-page button:focus-visible { outline: 2px solid #e95a13; outline-offset: 2px; }\n\n@media (max-width: 1050px) {\n  .matching-page { width: min(860px, calc(100% - 36px)); }\n  .matching-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n@media (max-width: 768px) {\n  .matching-page { width: 100%; min-height: 0; padding: 14px 12px 88px; }\n  .matching-hero { margin: 8px -12px 10px;  border-radius: 0 0 17px 17px; }\n  .matching-hero::before { right: 18px; left: 18px; }\n  .matching-header h1 { font-size: 1.08rem; }\n  .matching-header p { font-size: .76rem; }\n  .matching-page .suggestion-row { gap: 10px; padding: 1px 0 12px; }\n  .matching-grid { grid-template-columns: 1fr; gap: 11px; }\n  .matching-confirmed-section { margin-top: 22px; }\n  .matching-list-toolbar { margin-bottom: 9px; }\n  .matching-search { width: 100%; }\n  .matching-list-scroll { max-height: min(420px, calc(100dvh - 345px)); padding-right: 4px; }\n  .matching-list .match-card-mine { display: block; min-height: 205px; padding: 15px; }\n  .matching-list .match-body { margin: 15px 0; }\n  .matching-list .match-footer { margin-top: auto; }\n  .matching-page .match-card-mine { min-height: 205px; padding: 15px; border-radius: 15px; }\n  .matching-page .match-badge { top: 12px; right: 12px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
